// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"562":"266331b1","564":"94d44e70"}[chunkId] + ".chunk.css";
};